import { Coast, CompassRose, RhumbLines, ScaleOfMiles, Vignette } from '@brig/theme/ornaments';
import { button, paper } from '@brig/theme/styles';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { useAuth } from '../auth/useAuth.ts';
import { Cartouche } from '@brig/theme/components';
import { GridLabels } from '../components/GridLabels.tsx';
import { LanguageSwitcher } from '../components/LanguageSwitcher.tsx';
import { useDocumentTitle } from '../useDocumentTitle.ts';
import * as styles from './Landing.css.ts';

/** Title sheet for guests, in the manner of a mid-19th-century sea atlas. */
export function Landing() {
  const { t } = useTranslation();
  const { signIn, signUp } = useAuth();
  useDocumentTitle(t('landing.pageTitle'));

  return (
    <div className={styles.sea}>
      <RhumbLines originX={0.5} originY={0.3} />
      <GridLabels columns={10} rows={7} />
      <Coast className={styles.coastNorth} />
      <Coast className={styles.coastSouth} />

      <div className={styles.topBar}>
        <LanguageSwitcher />
      </div>

      <main className={styles.main}>
        <div className={styles.rose}>
          <CompassRose size="100%" />
        </div>

        <section className={`${paper} ${styles.sheet}`} aria-labelledby="landing-title">
          <Cartouche
            id="landing-title"
            size="lg"
            kicker={t('landing.chartTitle')}
            subtitle={t('landing.chartSubtitle')}
          >
            Salt <span className={styles.amp}>&amp;</span> Shot
          </Cartouche>

          <p className={styles.lead}>{t('landing.lead')}</p>

          <div className={styles.cta}>
            <button
              type="button"
              className={button({ tone: 'seal', size: 'lg' })}
              onClick={() => void signUp()}
            >
              {t('nav.join')}
            </button>
            <button
              type="button"
              className={button({ tone: 'label', size: 'lg' })}
              onClick={() => void signIn()}
            >
              {t('nav.signIn')}
            </button>
          </div>

          <Link to="/play" className={button({ tone: 'label' })}>
            {t('landing.playGuest')}
          </Link>
          <p className={styles.published}>{t('landing.playGuestNote')}</p>

          <Vignette className={styles.vignette} />

          <ul className={styles.features}>
            <li>{t('landing.features.wind')}</li>
            <li>{t('landing.features.steam')}</li>
            <li>{t('landing.features.ports')}</li>
          </ul>

          <div className={styles.cta}>
            <Link to="/ships" className={button({ tone: 'label' })}>
              {t('shipsPage.title')}
            </Link>
            <Link to="/how-to-play" className={button({ tone: 'label' })}>
              {t('learn.open')}
            </Link>
          </div>

          <p className={styles.published}>{t('landing.published')}</p>
          <Link to="/credits" className={styles.published}>
            {t('credits.link')}
          </Link>
        </section>

        <ScaleOfMiles caption={t('footer.scale')} color="#2F2418" fill="#F1E6C8" className={styles.scale} />
      </main>
    </div>
  );
}
